import React from 'react';
import Icon from '../../../components/AppIcon';

const SessionOverview = ({ sessions }) => {
  const activeCount = sessions?.filter(s => s?.status === 'active')?.length;
  const restCount = sessions?.filter(s => s?.status === 'rest')?.length;
  const pausedCount = sessions?.filter(s => s?.status === 'paused')?.length;
  const completedCount = sessions?.filter(s => s?.status === 'completed')?.length;

  const totalDuration = sessions?.reduce((acc, session) => acc + (session?.duration || 0), 0);
  const avgDuration = sessions?.length > 0 ? Math.floor(totalDuration / sessions?.length) : 0;

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs?.toString()?.padStart(2, '0')}`;
  };

  const stats = [
    {
      label: 'Active Sessions',
      value: activeCount,
      icon: 'Play',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      label: 'Rest Periods',
      value: restCount,
      icon: 'Clock',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      label: 'Paused',
      value: pausedCount,
      icon: 'Pause',
      color: 'text-muted-foreground',
      bgColor: 'bg-muted/30'
    },
    {
      label: 'Completed',
      value: completedCount,
      icon: 'CheckCircle',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10'
    }
  ];

  return (
    <div className="bg-surface border border-border rounded-xl p-6 mt-5 w-100 shadow-md">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl font-semibold text-foreground">Session Overview</h2>
          <p className="text-sm text-muted-foreground">
            Real-time monitoring • {sessions?.length} total clients
          </p>
        </div>
        <div className="text-right">
          <p className="text-sm text-muted-foreground">Average Duration</p>
          <p className="text-lg font-semibold text-foreground">{formatTime(avgDuration)}</p>
        </div>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {stats?.map((stat, index) => (
          <div key={index} className="text-center">
            <div className={`w-12 h-12 ${stat?.bgColor} rounded-xl flex items-center justify-center mx-auto mb-3`}>
              <Icon name={stat?.icon} size={24} className={stat?.color} />
            </div>
            <p className="text-2xl font-bold text-foreground mb-1">{stat?.value}</p>
            <p className="text-sm text-muted-foreground">{stat?.label}</p>
          </div>
        ))}
      </div>
      {/* Quick Stats */}
      <div className="mt-6 pt-6 border-t border-border">
        <div className="grid grid-cols-3 gap-4 text-center">
          <div>
            <p className="text-sm text-muted-foreground mb-1">Total Sessions Today</p>
            <p className="text-lg font-semibold text-foreground">{sessions?.length + 8}</p>
          </div>
          <div>
            <p className="text-sm text-muted-foreground mb-1">Peak Concurrent</p>
            <p className="text-lg font-semibold text-foreground">12</p>
          </div>
          <div>
            <p className="text-sm text-muted-foreground mb-1">Avg Completion</p>
            <p className="text-lg font-semibold text-foreground">94%</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionOverview;